// @ts-ignore
const yii: any = window.yii;

export default yii;
